export type GlobalLinks = {
  terms_url: string;
  privacy_url: string;
  shipping_url: string;
  returns_url: string;
  contact_url: string;
  cookie_url: string;
};

export const GLOBAL_LINK_FIELDS: Array<{ key: keyof GlobalLinks; label: string; description: string; placeholder: string }> = [
  { key: 'terms_url', label: 'Regulamin sklepu', description: 'Link do strony z regulaminem korzystania ze sklepu.', placeholder: '/regulamin/' },
  { key: 'privacy_url', label: 'Polityka prywatności', description: 'Link do strony z polityką prywatności i ochroną danych.', placeholder: '/polityka-prywatnosci/' },
  { key: 'shipping_url', label: 'Płatność i dostawa', description: 'Link do strony z informacjami o płatności, dostawie i kosztach.', placeholder: '/platnosc-i-dostawa/' },
  { key: 'returns_url', label: 'Reklamacja i zwroty', description: 'Link do strony z procedurą zwrotów i reklamacji.', placeholder: '/reklamacja-i-zwroty/' },
  { key: 'contact_url', label: 'Kontakt', description: 'Link do strony z formularzem kontaktowym lub danymi kontaktowymi.', placeholder: '/kontakt/' },
  { key: 'cookie_url', label: 'Polityka cookies', description: 'Link do strony z informacjami o plikach cookies.', placeholder: '/polityka-cookies/' },
];

export function emptyGlobalLinks(): GlobalLinks {
  return {
    terms_url: '',
    privacy_url: '',
    shipping_url: '',
    returns_url: '',
    contact_url: '',
    cookie_url: '',
  };
}

export function isValidGlobalLink(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return true;
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) return true;

  try {
    const parsed = new URL(trimmed);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}
